// @ts-nocheck
import { UPDATE_INTEREST_ERROR, UPDATE_INTEREST_LOADING, UPDATE_INTEREST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const UpdateInterestReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_INTEREST_LOADING:
            return Object.assign({}, state, { loading: true })
        case UPDATE_INTEREST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case UPDATE_INTEREST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

